import React, { useEffect, useState } from 'react';

// List of available background images
const bgImages = [
  'bg1.png', 'bg2.png', 'bg3.png', 'bg4.png',
  'bg7.png', 'bg8.png', 'bg9.png', 'bg10.png',
  'bg11.png', 'bg12.png', 'bg13.png', 'bg14.png'
];

const BackgroundImages = () => {
  const [bg, setBg] = useState('');

  useEffect(() => {
    // Pick a random image on each refresh
    const randomIndex = Math.floor(Math.random() * bgImages.length);
    setBg(bgImages[randomIndex]);
  }, []);

  if (!bg) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: -1,
        backgroundImage: `url(/assets/img/background/${bg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        opacity: 1, 
        pointerEvents: 'none', 
      }}
      aria-hidden="true"
    />
  );
};

export default BackgroundImages;
